export default __webpack_public_path__ + "static/media/grand_raffle_mandiri.1c95626a.jpeg";